import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FileText, Shield, RefreshCcw, Scale } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../context/LangContext";

export default function Legal() {
  const { t } = useLang();
  const { hash } = useLocation();
  const [legal, setLegal] = useState(null);

  useEffect(() => {
    api("/legal").then(setLegal).catch(() => setLegal({}));
  }, []);

  useEffect(() => {
    if (legal && hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [legal, hash]);

  const sections = [
    { id: "terms", icon: FileText, title: t("terms_t"), body: legal?.terms },
    { id: "privacy", icon: Shield, title: t("privacy_t"), body: legal?.privacy },
    { id: "refund", icon: RefreshCcw, title: t("refund_t"), body: legal?.refund },
  ].filter((s) => s.body);

  return (
    <div data-testid="legal-page" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-teal-700/10 text-teal-700">
          <Scale className="h-6 w-6" />
        </div>
        <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">{t("legal_t")}</h1>
      </div>
      <div className="mt-8 space-y-6">
        {sections.map((s) => (
          <section key={s.id} id={s.id} data-testid={`legal-${s.id}`} className="scroll-mt-24 rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
            <h2 className="font-heading flex items-center gap-2.5 text-xl font-bold text-slate-900">
              <s.icon className="h-5 w-5 text-teal-600" /> {s.title}
            </h2>
            <p className="mt-4 text-sm sm:text-base text-slate-600 leading-relaxed whitespace-pre-line">{s.body}</p>
          </section>
        ))}
        {legal && sections.length === 0 && (
          <p data-testid="legal-empty" className="text-center text-sm text-slate-500">—</p>
        )}
      </div>
    </div>
  );
}
